<template>
	<div class="three-dimensional-imaging-list">
		<div class="three-dimensional-imaging-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Three-dimensional Imaging</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>
				<ul class="">
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Obtain the depth information of the triangulation range.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Point cloud registration and blending.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">ICP algorithm.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Texture Mapping.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Phase unpacking.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Non-sinusoidal correction.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_optics_09.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
            };
        }
    }

</script>

<style scoped="">


	.ll {
		width: calc(100% - .625rem);
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
	}

	.list > ul > li {
		width: 100%;
	}

	.list > ul {
		width: 100%;
		height: 10.5rem;
	}

	.list > img {
		width: 100%;
		margin-bottom: 2.75rem;
	}

	.list {
		width: 54.5rem;
		height: 34.5rem;
		border: none;
		margin-left: 7rem;
	}

	.three-dimensional-imaging-con {
		width: 61.5rem;
		border: none;
		margin-left: 0px;
	}

	.three-dimensional-imaging-list {
		width: 100%;
		height: 45.3125rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-three-dimensional-imaging.vue